import { useNavigatePreserveQuery } from "lib/hooks/useNavigatePreserveQuery";
import { useLocation } from "react-router-dom";
import useLayoutConfigStore from "store/layout-config-store/useLayoutConfigStore";
import { navigationItems } from "v2/routes";

const withFooterNav = (Component: React.ComponentType) => {
  return ({ ...props }: any) => {
    const navigate = useNavigatePreserveQuery();
    const { isShowFooter, setIsShowFooter } = useLayoutConfigStore();
    const location = useLocation();

    const handleClick = (route: string) => {
      navigate(route);
    };

    return isShowFooter ? (
      <Component
        isShowFooter={isShowFooter}
        location={location}
        handleClick={handleClick}
        footerLogos={navigationItems}
        {...props}
      />
    ) : (
      <></>
    );
  };
};

export default withFooterNav;
